export default {
    //Modal
    on_cancel_title: 'Cancel',
    on_process_title: 'Confirm'
}